import { AgencyModel } from './agency.model';

export class AgencyEvent {
  constructor(
    public id: string | number,
    public verb: string,
    public agency: AgencyModel
  ) {}
}
